<template>
    <card-sections :title="title" :subtitle="subtitle" :hideMsg="true" :tabName="'admins'">
        <div class="form-group input-group py-3 m-0">
            {{
                $page.props.auth.user.is_super_admin ?
                    Lang.get('employerdashboard::pages/settings/admins.super_admin_description')
                    : Lang.get('employerdashboard::pages/settings/admins.description')
            }}
            <button
                class="btn btn-primary font-poppins font-weight-bold btn-orange border-radius-19 px-4 mt-3 collapsed"
                id="heading_new"
                data-toggle="collapse"
                data-target="#collapse_new"
                aria-expanded="false"
                aria-controls="collapse_new"
                v-if="showAddNewButton && this.$page.props.auth.user.is_super_admin"
                @click="showInviteAdminForm">
                {{ Lang.get('employerdashboard::pages/settings/admins.add') }}
            </button>
        </div>

        <div id="adminAccordion">
            <div v-if="this.$page.props.auth.user.is_super_admin" id="collapse_new"
                 class="collapse" aria-labelledby="heading_new"
                 data-parent="#adminAccordion">
                <div class="card-body px-0 border-bottom font-poppins font-weight-light color-dark-blue">
                    <template v-if="addNewSuccess">
                        <h4>
                            {{ Lang.get('employerdashboard::pages/settings/admins.invite.title') }}
                        </h4>
                        <div class="row">
                            <div class="col-12 pb-2">
                                {{ Lang.get('employerdashboard::pages/settings/admins.invite.send') }}
                                {{ fullname(form.firstname, form.middlename, form.lastname) }}
                                ({{ form.email }})
                            </div>
                            <div class="col-12">
                                <img src="/img/employer-dashboard/humaan-envelope.svg">
                            </div>
                        </div>
                    </template>
                    <template v-if="!addNewSuccess">
                        <h4 class="mt-3">
                            {{ Lang.get('employerdashboard::pages/settings/admins.new') }}
                        </h4>
                        <div class="row">
                            <div class="col-md-3">
                                <text-input
                                    id="newAdminFirstname"
                                    v-model="form.firstname"
                                    :error="errors.firstname"
                                    :label="Lang.get('employerdashboard::shared.firstname')"
                                    :placeholder="Lang.get('employerdashboard::shared.firstname')"/>

                            </div>
                            <div class="col-md-2">
                                <text-input
                                    id="newAdminMiddlename"
                                    v-model="form.middlename"
                                    :error="errors.middlename"
                                    :label="Lang.get('employerdashboard::shared.middlename')"
                                    :placeholder="Lang.get('employerdashboard::shared.middlename')"/>
                            </div>
                            <div class="col-md-3">
                                <text-input
                                    id="newAdminLastname"
                                    v-model="form.lastname"
                                    :error="errors.lastname"
                                    :label="Lang.get('employerdashboard::shared.lastname')"
                                    :placeholder="Lang.get('employerdashboard::shared.lastname')"/>
                            </div>
                            <div class="col-md-4">
                                <text-input
                                    id="newAdminEmail"
                                    v-model="form.email"
                                    type="email"
                                    :error="errors.email"
                                    :label="Lang.get('employerdashboard::shared.email')"
                                    :placeholder="Lang.get('employerdashboard::shared.email')"/>
                            </div>
                        </div>
                        <div class="pt-3 pb-4">
                            <button
                                class="btn btn-primary font-poppins font-weight-bold btn-orange border-radius-19 px-4"
                                @click="addNew()" :disabled="sending">
                                {{ Lang.get('employerdashboard::shared.save') }}
                            </button>
                        </div>
                    </template>
                </div>
            </div>
            <div class="card border-0 employees-header">
                <div class="card-body px-4 py-1 row">
                    <div class="col-10">
                        {{ Lang.get('employerdashboard::pages/settings/admins.name') }}
                    </div>
                    <div class="col-2 text-center">
                        {{ Lang.get('employerdashboard::pages/settings/admins.2fa_active') }}
                    </div>
                </div>
            </div>
            <div class="card border-0" v-for="(admin, index) in admins.data" :key="admin.id"
                 @click="setAddNewButtonVisibilty(true)">
                <div class="card-header px-4 py-3 bg-white cursor-pointer collapsed row"
                     :id="'heading_' + admin.id " data-toggle="collapse"
                     :data-target="'#collapse_' + admin.id" aria-expanded="false"
                     :aria-controls="'collapse_' + admin.id">
                    <div class="col-10">
                        <span class="font-poppins font-weight-light font-size-18 color-blue">
                            {{ admin.fullname }}
                        </span>
                    </div>
                    <div class="col-2 text-center">
                        <i class="fa fa-check-circle color-blue" v-if="admin.has_2fa_enabled">
                        </i>
                        <i class="fa fa-times-circle color-blue" v-else></i>
                    </div>
                </div>
                <div :id="'collapse_' + admin.id" class="collapse"
                     :aria-labelledby="'heading' + admin.id" data-parent="#adminAccordion">
                    <div
                        class="card-body px-0 border-bottom font-poppins font-weight-light color-dark-blue">
                        <div class="row">
                            <div class="col-md-3">
                                <text-input
                                    :id="'first_name_' + admin.uuid"
                                    v-model="admin.firstname"
                                    :label="Lang.get('employerdashboard::shared.firstname')"
                                    :placeholder="Lang.get('employerdashboard::shared.first_name')"
                                    disabled="disabled"/>
                            </div>
                            <div class="col-md-2">
                                <text-input
                                    :id="'middle_name_' + admin.uuid"
                                    v-model="admin.middlename"
                                    :label="Lang.get('employerdashboard::shared.middlename')"
                                    :placeholder="Lang.get('employerdashboard::shared.middlename')"
                                    disabled="disabled"/>
                            </div>
                            <div class="col-md-3">
                                <text-input
                                    :id="'last_name_' + admin.uuid"
                                    v-model="admin.lastname"
                                    :label="Lang.get('employerdashboard::shared.lastname')"
                                    :placeholder="Lang.get('employerdashboard::shared.lastname')"
                                    disabled="disabled"/>
                            </div>
                            <div class="col-md-4">
                                <text-input
                                    :id="'email_' + admin.uuid"
                                    v-model="admin.email"
                                    :label="Lang.get('employerdashboard::shared.email')"
                                    :placeholder="Lang.get('employerdashboard::shared.email')"
                                    disabled="disabled"/>
                            </div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-12">
                                <a
                                    v-if="$page.props.auth.user.is_super_admin"
                                    type="button"
                                    class="font-poppins color-dark-blue font-weight-medium px-4 float-right"
                                    @click="setConfirmation(admin.id, index, admin.fullname, 'delete')"
                                    :disabled="sending">
                                    {{ Lang.get('employerdashboard::shared.delete') }}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card border-0"
                 v-for="(invitedAdmin, indexInvited) in invitedAdmins.data"
                 :key="'invite_' + indexInvited">
                <div class="card-header px-4 py-3 bg-white cursor-pointer collapsed border-top row"
                     :id="'heading_invite_' + invitedAdmin.id "
                     data-toggle="collapse"
                     :data-target="'#collapse_invite_' + invitedAdmin.id"
                     aria-expanded="false"
                     :aria-controls="'collapse_invite_' + invitedAdmin.id">
                    <div class="col-8">
                        <span class="font-poppins font-weight-light font-size-18 color-blue">
                            {{ invitedAdmin.fullname }}
                        </span>
                    </div>
                    <div class="col-2">
                        <span class="badge badge-success font-poppins font-size-11 font-weight-semibold float-right mt-1 py-1 px-2">
                            {{ Lang.get('employerdashboard::shared.invited') }}
                        </span>
                    </div>
                </div>
                <div :id="'collapse_invite_' + invitedAdmin.id" class="collapse"
                     :aria-labelledby="'heading_invite_' + invitedAdmin.id"
                     data-parent="#adminAccordion">
                    <div class="card-body px-0 font-poppins font-weight-light color-dark-blue">

                        <custom-flash-messages
                            :message="update_invite && update_invite.hasOwnProperty(invitedAdmin.id) ? update_invite[invitedAdmin.id] : null"></custom-flash-messages>
                        <custom-flash-messages
                            :message="resent_invite && resent_invite.hasOwnProperty(invitedAdmin.id) ? resent_invite[invitedAdmin.id] : null"></custom-flash-messages>

                        <div class="row">
                            <div class="col-md-8 col-lg-4">
                                <text-input
                                    :id="'admin_mail_invite_first_name_' + invitedAdmin.id + '_' + invitedAdmin.email"
                                    v-model="invitedAdmin.firstname"
                                    :error="errors.firstname"
                                    :label="Lang.get('employerdashboard::shared.firstname')"
                                    :placeholder="Lang.get('employerdashboard::shared.first_name')"/>
                            </div>
                            <div class="col-md-4 col-lg-2 mt-3 mt-md-0">
                                <text-input
                                    :id="'admin_mail_invite_middle_name_' + invitedAdmin.id + '_' + invitedAdmin.email"
                                    v-model="invitedAdmin.middlename"
                                    :error="errors.middlename"
                                    :label="Lang.get('employerdashboard::shared.middlename')"
                                    :placeholder="Lang.get('employerdashboard::shared.middlename')"/>
                            </div>
                            <div class="col-md-8 col-lg-4 mt-3 mt-md-0">
                                <text-input
                                    :id="'admin_mail_invite_last_name_' + invitedAdmin.id + '_' + invitedAdmin.email"
                                    v-model="invitedAdmin.lastname"
                                    :error="errors.lastname"
                                    :label="Lang.get('employerdashboard::shared.lastname')"
                                    :placeholder="Lang.get('employerdashboard::shared.lastname')"/>
                            </div>
                            <div class="col-md-8 col-lg-6 mt-3">
                                <label
                                    :id="'admin_mail_invite_email_' + invitedAdmin.id + '_' + invitedAdmin.email"
                                    class="color-dark-blue font-poppins">
                                    {{ Lang.get('employerdashboard::shared.email') }}
                                </label>
                                <input type="text" class="form-control"
                                       :id="'admin_mail_invite_' + invitedAdmin.id"
                                       :value="invitedAdmin.email" disabled="disabled">
                            </div>
                        </div>
                        <div class="row mt-3 d-flex justify-content-between"
                             v-if="$page.props.auth.user.is_super_admin">
                            <div class="col-12 col-md-3 mt-3">
                                <!-- Button trigger save -->
                                <button
                                    class="btn btn-primary font-poppins font-weight-bold"
                                    @click="update(indexInvited, invitedAdmin.id)"
                                    :disabled="sending">
                                    {{ Lang.get('employerdashboard::shared.save') }}
                                </button>
                            </div>
                            <div class="col-12 col-md-9 col-lg-5 mt-3 text-md-right">
                                <!-- Button trigger confirmation modal -->
                                <button
                                    class="btn btn-danger font-weight-medium font-poppins font-weight-medium"
                                    @click="setConfirmation(invitedAdmin.id, indexInvited, invitedAdmin.fullname, 'withdraw_invitation')">
                                    {{ Lang.get('employerdashboard::shared.withdraw_invitation') }}
                                </button>
                                <button
                                    class="btn btn-link pr-4 pr-md-0 font-poppins font-weight-medium"
                                    @click="inviteAgain(invitedAdmin.id, indexInvited)">
                                    {{ Lang.get('employerdashboard::shared.invite_again') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <template v-slot:pagination :links="admins.links"/>

        <!-- Modal -->
        <template v-if="confirmation">
            <div class="modal fade" id="confirmationModal" tabindex="-1" role="dialog"
                 aria-labelledby="confirmationModalLabel" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header" v-if="confirmation.modalTitle">
                            <h5 class="modal-title" id="confirmationModalLabel">{{ confirmation.modalTitle }}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            {{ confirmation.modalDescription }}
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">
                                {{ confirmation.cancelButtonText }}
                            </button>
                            <button
                                v-if="confirmation.confirmButton === 'delete'"
                                type="button"
                                class="btn btn-primary"
                                @click="deactivate(confirmation.index, confirmation.id)"
                                :disabled="sending">{{ confirmation.confirmButtonText }}
                            </button>
                            <button
                                v-if="confirmation.confirmButton === 'withdraw_invitation'"
                                type="button"
                                class="btn btn-primary"
                                @click="deleteInvite(confirmation.index, confirmation.id)"
                                :disabled="sending">{{ confirmation.confirmButtonText }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </card-sections>
</template>

<script>
import CardSections from "@/Pages/Settings/Shared/CardSections";
import TextInput from "@/Shared/TextInput";
import Pagination from "@/Shared/Pagination";
import FlashMessages from "@/Shared/FlashMessages";
import CustomFlashMessages from "@/Shared/CustomFlashMessages";

export default {
    metaInfo() {
        return {
            title: this.$page.props.auth.user.is_super_admin ?
                Lang.get('employerdashboard::pages/settings/admins.super_admin_title') :
                Lang.get('employerdashboard::pages/settings/admins.title'),
        }
    },
    components: {
        CardSections,
        FlashMessages,
        CustomFlashMessages,
        Pagination,
        TextInput,
    },
    props: {
        errors: Object,
        admins: Object,
        invitedAdmins: Object,
        update_invite: Object,
        resent_invite: Object,
    },
    data() {
        return {
            sending: false,
            showAddNewButton: true,
            addNewSuccess: false,
            confirmation: {
                id: null,
                index: null,
                fullname: null,
                modalTitle: null,
                modalDescription: null,
                confirmButton: null,
                confirmButtoText: null,
                cancelButtonText: null,
            },
            form: {
                firstname: null,
                middlename: null,
                lastname: null,
            },
            title: this.$page.props.auth.user.is_super_admin ?
                Lang.get('employerdashboard::pages/settings/admins.super_admin_title') :
                Lang.get('employerdashboard::pages/settings/index.title'),
            subtitle: this.$page.props.auth.user.is_super_admin ?
                Lang.get('employerdashboard::pages/settings/admins.super_admin_subtitle') :
                Lang.get('employerdashboard::pages/settings/admins.subtitle'),
        }
    },
    methods: {
        url() {
            return location.href;
        },

        showInviteAdminForm() {
            this.setAddNewButtonVisibilty(false);
            this.addNewSuccess = false;
            this.form = {}

            $('#collapse_new').on('hidden.bs.collapse', function () {
                $('#collapse_new').collapse('show');
            });
        },

        setAddNewButtonVisibilty(visible) {
            this.showAddNewButton = visible;
        },

        addNew() {
            this.$inertia.post(this.route('nl.employerdashboard.settings.admin.save.attempt', {
                'company_as_uuid': this.$page.props.auth.user.selected_company.uuid,
            }), this.form, {
                onBefore: () => {
                    this.sending = true;
                },
                onSuccess: () => {
                    return Promise.all([
                        this.addNewSuccess = this.$page.props.flash.success,
                        this.setAddNewButtonVisibilty(true),
                    ]);
                },
                onFinish: () => {
                    this.sending = false;
                }
            });
        },

        fullname(firstname, middlename, lastname) {
            return middlename ? firstname + ' ' + middlename + ' ' + lastname : firstname + ' ' + lastname;
        },

        update(index, inviteId) {
            if (inviteId !== this.invitedAdmins.data[index].id) {
                return;
            }

            const updateForm = {
                firstname: this.invitedAdmins.data[index].firstname,
                middlename: this.invitedAdmins.data[index].middlename,
                lastname: this.invitedAdmins.data[index].lastname,
            }

            this.$inertia.put(this.route('nl.employerdashboard.settings.admin.update-invite.attempt', {
                'company_as_uuid': this.$page.props.auth.user.selected_company.uuid,
                'companyRepresentativeInvite': this.invitedAdmins.data[index].id,
            }), updateForm, {
                onBefore: () => {
                    this.sending = true;
                },
                onFinish: () => {
                    this.sending = false;
                }
            });
        },

        inviteAgain(inviteId, index) {
            if (inviteId !== this.invitedAdmins.data[index].id) {
                return;
            }

            const resendForm = {
                firstname: this.invitedAdmins.data[index].firstname,
                middlename: this.invitedAdmins.data[index].middlename,
                lastname: this.invitedAdmins.data[index].lastname,
            }

            this.$inertia.put(this.route('nl.employerdashboard.settings.admin.resend-invite.attempt', {
                'company_as_uuid': this.$page.props.auth.user.selected_company.uuid,
                'companyRepresentativeInvite': this.invitedAdmins.data[index].id,
            }), resendForm, {
                onBefore: () => {
                    this.sending = true;
                },
                onSuccess: () => {
                    return Promise.all([
                        this.addNewSuccess = this.$page.props.flash.success,
                        this.setAddNewButtonVisibilty(true),
                    ]);
                },
                onFinish: () => {
                    this.sending = false;
                }
            })
        },

        deleteInvite(index, inviteId) {
            if (inviteId !== this.invitedAdmins.data[index].id) {
                return;
            }

            this.$inertia.delete(this.route('nl.employerdashboard.settings.admin.delete-invite.attempt', {
                'company_as_uuid': this.$page.props.auth.user.selected_company.uuid,
                'companyRepresentativeInvite': this.invitedAdmins.data[index].id,
            }), {
                onBefore: () => {
                    this.hideModal();
                    this.sending = true;
                },
                onFinish: () => {
                    this.sending = false;
                }
            });
        },

        deactivate(index, adminId) {
            if (adminId !== this.admins.data[index].id) {
                return;
            }

            this.$inertia.delete(this.route('nl.employerdashboard.settings.admin.delete.attempt', {
                'company_as_uuid': this.$page.props.auth.user.selected_company.uuid,
                'company_representative_as_uuid': this.admins.data[index].uuid,
            }), {
                onBefore: () => {
                    this.hideModal();
                    this.sending = true;
                },
                onFinish: () => {
                    this.sending = false;
                }
            });
        },

        setConfirmation(id, index, fullname, action) {
            this.confirmation.id = id;
            this.confirmation.index = index;
            this.confirmation.fullname = fullname;
            this.confirmation.confirmButton = action;
            switch (action) {
                case 'delete':
                    this.confirmation.confirmButtonText = this.Lang.get('employerdashboard::pages/settings/admins.delete.modal.confirmation_button')
                    this.confirmation.cancelButtonText = this.Lang.get('employerdashboard::pages/settings/admins.delete.modal.cancel_button')
                    this.confirmation.modalTitle = this.Lang.get('employerdashboard::pages/settings/admins.delete.modal.title')
                    this.confirmation.modalDescription = this.Lang.get('employerdashboard::pages/settings/admins.delete.modal.description', { 'fullname': fullname });
                    break;
                case 'withdraw_invitation':
                    this.confirmation.confirmButtonText = this.Lang.get('employerdashboard::pages/settings/admins.withdraw_invitation.modal.confirmation_button')
                    this.confirmation.cancelButtonText = this.Lang.get('employerdashboard::pages/settings/admins.withdraw_invitation.modal.cancel_button')
                    this.confirmation.modalTitle = this.Lang.get('employerdashboard::pages/settings/admins.withdraw_invitation.modal.title')
                    this.confirmation.modalDescription = this.Lang.get('employerdashboard::pages/settings/admins.withdraw_invitation.modal.description', { 'fullname': fullname });
                    break;
            }
            $('#confirmationModal').modal('show');
        },

        hideModal() {
            $('#confirmationModal').modal('hide');
        }
    },
}
</script>
